import ViewBase from "../../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../../framework/tools/scrollview/listview";
import { InsideTaskItem } from "./inside_task_item";

const {ccclass, property} = cc._decorator;

@ccclass
export class InsideTaskView extends ViewBase {
    @property(cc.ScrollView)
    itemListScrollView: cc.ScrollView = null

    @property(cc.Node)
    itemListView: cc.Node = null

    @property(cc.Node)
    nodeItemListConent: cc.Node = null

    @property(cc.Node)
    prefab:cc.Node = null;

    @property(cc.Node)
    taskRoot:cc.Node = null;

    @property(cc.Animation)
    anim:cc.Animation = null;

    @property(cc.Node)
    mask:cc.Node = null;

    isInit:boolean = false;

    clickItem:(data:any)=>void
    
    protected m_list: ListView = null
    onLoad(){
        let list: ListView = new ListView({
            scrollview: this.itemListScrollView,
            view: this.itemListView,
            content: this.nodeItemListConent,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            column: 1,
            row: 5,
            gap_x:10,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
    }

    initView(func){
        this.clickItem = func;
        this.isInit = false;
    }

    setAnimName(state:number){
        let animName = 'anim_Baoxiang1'
        if (state == 0) {
            animName = 'anim_Baoxiang2'
        }
        this.anim.play(animName);
    }

    setItemData(data:any[]){
        if (!this.isInit) {
            this.m_list.set_data(data)
        }else{
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                this.refreshOneItem(i,item);
            }
        }
        this.isInit = true;
    }

    refreshOneItem(index:number,data:any){
        this.m_list.refresh_item(index,data)
    }

    protected update_list_item(itemNode: cc.Node, data: any, index: number){
        itemNode.getComponent(InsideTaskItem).refreshItem(data,this.clickItem);
    }

    setBtnPos(pos:cc.Vec2){
        this.anim.node.setPosition(pos);
    }

    getAnimBtn(){
        return this.anim.node;
    }

    isRun:boolean = false;
    isShowPanel(isShow:boolean,isUseAnim:boolean = true,func?:Function){
        if (this.isRun) {
            return;
        }
        let vec = cc.Vec2.ZERO;
        this.mask.active = isShow;
        this.taskRoot.stopAllActions();
        if (!isShow) {
            vec = cc.v2(1000,0);
        }
        if (!isUseAnim) {
            this.taskRoot.setPosition(vec)
            this.isRun = false;
        }else{
            this.isRun = true;
            let moveTo = cc.moveTo(0.2,vec);
            this.taskRoot.runAction(cc.sequence(moveTo,cc.callFunc(()=>{
                func && func();
                this.isRun = false;
            })));
        }
    }
}
